<template>
  <div class="show-more-button" @click="showMore">
    <span>
      <b v-if="currentCount != totalCount">더보기</b>
      <b v-else>닫기</b>
      <span class="pagination">
        <span class="current"> {{ currentCount }} </span> /
        <span class="end"> {{ totalCount }}</span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    currentCount: {
      type: Number,
      required: false,
      default: 15
    },

    totalCount: {
      type: Number,
      required: false,
      default: 60
    }
  },
  methods: {
    showMore() {
      if (this.currentCount < this.totalCount) {
        this.$emit('showMore', 'more');
      } else {
        this.$emit('showMore', 'init');
      }
    }
  }
};
</script>

<style lang="scss">
.show-more-button {
  @include border-radius;
  padding: 20px 0;
  background: $second-background;
  border: 1px solid $border-color;
  text-align: center;
  cursor: pointer;
  transition: 0.1s;

  &.max {
    cursor: not-allowed !important;
    b {
      color: $text-gray1 !important;
    }
  }
  b {
    color: $text-gray1;
  }

  &:hover {
    b {
      color: $default-text;
    }
  }

  .pagination {
    @include border-radius(100px);
    display: inline-block;
    margin-left: 10px;
    padding: 3px 20px;
    background: $show-more;
    color: $second-background;
    font-size: 14px;
  }
}
</style>
